import { render, staticRenderFns } from "./BusinessPersonalDetails.vue?vue&type=template&id=083430bd"
import script from "./BusinessPersonalDetails.vue?vue&type=script&lang=js"
export * from "./BusinessPersonalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports